import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getLinkIframeCard } from 'services/payment';
import { CustomNotification } from 'common/components';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';

const keys = {
  addCreditCardIframeUrl: ['payment', 'add-card'],
  getBillingProperties: (memberId) => [
    'payment',
    'get-member-billing-properties',
    { params: { memberId: parseInt(memberId) } },
  ],
};

/**
 *? GET
 *? /api/payment/add-card
 */
const useQueryAddCreditCardIframeUrl = ({ memberId, ...options }) => {
  return useQuery({
    queryKey: keys.addCreditCardIframeUrl,
    queryFn: async () => {
      const res = await getLinkIframeCard({
        memberId,
        paymentEndpointType: null,
      });

      const { isSuccess, message, data } = res || {};

      if (!isSuccess) {
        CustomNotification.error(message || 'Server Error');
      }

      return data;
    },
    ...options,
  });
};

/**
 *? GET
 *? /api/payment/get-member-billing-properties
 */
const useQueryBillingProperties = ({ memberId, ...options }) => {
  const queryClient = useQueryClient();

  const { canAccessBilling } = useCheckCreditCardPermission();

  const query = useQuery({
    queryKey: keys.getBillingProperties(memberId),
    enabled: Boolean(memberId) && canAccessBilling,
    retry: 0,
    ...options,
  });

  const invalidateBillingProperties = () => {
    queryClient.invalidateQueries({
      queryKey: keys.getBillingProperties(memberId),
    });
  };

  return {
    billingProperties: query?.data ?? {},
    invalidateBillingProperties,
    ...query,
  };
};

export { useQueryAddCreditCardIframeUrl, useQueryBillingProperties };
